import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../shared/modals';
import { useStore } from '../../shared/store';
import { useDrawer } from '../../shared/drawer';
import { Table } from "../../elements/table";
import { PageBody } from '../../elements/page-body';
import { RenderFilters } from '../../elements/render-filters/render-filters';
//import { DetectedRefuelingsFilter } from './detected-refuelings-filter';
import { useHttpClient } from '../../shared/http-client';
import { Map } from '../../elements/map';
import { AggressiveDrivingEventsFilter } from './aggressive-driving-events-filter';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default marker icon in react-leaflet
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconAnchor: [18, 41], // Half of the icon width and full height
    popupAnchor: [1, -34],
});

L.Marker.prototype.options.icon = DefaultIcon;

export const AggressiveDrivingEvents = () => {
    const { t } = useTranslation();
    const { open, close } = useModal();
    const { open: openDrawer, close: closeDrawer } = useDrawer();
    const { api, state } = useHttpClient();
    const { get, set } = useStore();
    
    const filtrosGuardados = get('aggressive-driving') || {};
    const [refresh, setRefresh] = useState<string | null>(null);
    const [filters, setFilters] = useState<any>(filtrosGuardados);
    const [query, setQuery] = useState<any>(new URLSearchParams(filtrosGuardados));
    const [vehicles, setVehicles] = useState<any[]>([]);
    const [drivers, setDrivers] = useState<any[]>([]);
    const [showingMap, setShowingMap] = useState<boolean>(true);

    useEffect(() => {
        api('/fleet/vehicles/', 'GET');
    }, []);



    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };

    const handleFilters = () => {
        openDrawer('common.filter.title', <AggressiveDrivingEventsFilter close={close} doFilter={doFilter} item={filters} />);
    };

    const doFilter = (filters: any) => {
        set('aggressive-driving', filters);
        setFilters(filters);
        // Actualizar el query inmediatamente con los nuevos filtros
        setQuery(new URLSearchParams(filters));
        // Resetear la paginación cuando se aplica un filtro
        setRefresh(Date.now().toString());
        closeDrawer();
    };

    const showMap = (item: any) => {
        if (item.avl_data.latitude && item.avl_data.longitude) {
            const MapWrapper = () => (
                <div className='w-full h-96 flex flex-col'>
                    <div className='text-[10px] font-semibold'>{t('common.form-label.tipo_evento')}: <span className='text-[10px] font-normal'>{t(item.event_type)}</span></div>
                    <div className='text-[10px] font-semibold'>{t('common.label.duracion-segundos')}: <span className='text-[10px] font-normal'>{item.duration_ms / 1000}</span></div>
                    <div className='text-[10px] font-semibold'>{t('common.label.vehiculo')}: <span className='text-[10px] font-normal'>{item.vehicle.plate}</span></div>
                    <div className='text-[10px] font-semibold'>{t('common.label.conductor')}: <span className='text-[10px] font-normal'>{item.driver.full_name}</span></div>
                    <div className="mt-2 flex-grow">
                        <Map longitude={item.avl_data.longitude} latitude={item.avl_data.latitude} />
                    </div>
                    <div className='text-[13px] pt-2'>{item.address}</div>
                </div>
            );

            open('custom', { title: '' }, <MapWrapper />);
        }
    };

    useEffect(() => {
        if (state.data && state.path.includes('vehicles')) {
            if (Array.isArray(state.data.results)) {
                setVehicles(state.data.results);
                api('/fleet/drivers/', 'GET');
            }
        }
        if (state.data && state.path.includes('drivers')) {
            if (Array.isArray(state.data.results)) {
                setDrivers(state.data.results);
            }
        }
    }, [state]);



    return (
        <PageBody
            title={'common.label.conducion-peligrosa'}
            filterAction={handleFilters}
            filters={filters}
        >

            <>
                {Object.keys(filters).length > 0 ? (
                    <RenderFilters filters={filters} vehicles={vehicles} drivers={drivers} />
                ) : (
                    ''
                )}

                <Table
                        path="/fleet/aggressive-driving-events/"
                        deletePath="/fleet/aggressive-driving-events/"
                        callBeforeDrawerClosed={handleClose}
                        withPagination
                        noEdit
                        onShow={showMap}
                        onShowCondition={(item: any) => item.avl_data.latitude && item.avl_data.longitude}
                        query={query}
                        refresh={refresh}
                        headers={[
                            {
                                key: 'vehicle',
                                subKey: 'plate',
                                label: 'common.label.vehiculo'
                            },
                            {
                                key: 'driver',
                                subKey: 'full_name',
                                label: 'common.label.conductor'
                            },
                            {
                                key: 'timestamp',
                                type: 'datetime',
                                label: 'common.label.fecha-hora',
                            },
                            {
                                key: 'event_type',
                                label: 'common.form-label.tipo_evento',
                                formatter: (value: any) => (value ? t(value.toUpperCase()) : '-'),
                            },
                        ]}
                    />

            </>
        </PageBody>
    );
};